export default __webpack_public_path__ + "static/media/shoes2.6caaf299.svg";